export { InstanceBlockInput as Input } from './input'
export {
  InstancePropertiesPanel as PropertiesPanel,
  FullViewInstancePropertiesPanel as FullViewPropertiesPanel,
} from './properties-panel'
